<header class="component-customer-panel component-customer-panel0" data-component="true"
        data-component-id="component-customer-panel0" style="">
  <button title="Close" type="button" class="customer-login-close mfp-close"><span class="ihs-close"></span></button>
  <div class="customer-top-section">
    <section class="content customer-login">
      <div>
        <h2>Customer Logins</h2>
        <p>Obtain the data you need to make the most informed decisions by accessing our extensive portfolio of
          information, analytics, and expertise. Sign in to the product or service center of your choice.</p>
        <a class="primary-button" href="https://ihsmarkit.com/login.html">View All Logins</a>
      </div>
    </section>

    <section id="topsiteHeader" class="content" style="">
      <div class="top-sites">
        <h3>Top Sites</h3>
        <article class="ihsenergy">
          <a cookiename="ihsenergy" itemid="139498" fromflag="0" onclick="AddToMyLogin(this);"
             href="https://my.ihs.com/energy">
            <h4>Energy</h4>
          </a>
        </article>
        <article class="financialservices">
          <a cookiename="financialservices" itemid="293852" fromflag="0" onclick="AddToMyLogin(this);"
             href="https://products.markit.com">
            <h4>Financial Services</h4>
          </a>
        </article>
        <article class="markithub">
          <a cookiename="markithub" itemid="297261" fromflag="0" onclick="AddToMyLogin(this);"
             href="https://www.hub.com/hub/">
            <h4>Hub</h4>
          </a>
        </article>
        <article class="MarkitSERV">
          <a cookiename="MarkitSERV" itemid="270993" fromflag="0" onclick="AddToMyLogin(this);"
             href="https://ihsmarkit.com/products/markitserv.html">
            <h4>MarkitSERV</h4>
          </a>
        </article>
      </div>
    </section>
  </div>
  <section class="content" id="myLoginheader" style="display:none">
    <div id="panelShowMyLogin">
      <h3>My Sites</h3>
      <div id="topHeader">
        <ul class="my-sites unstyled"></ul>
      </div>
    </div>
  </section>
</header>
<header class="utility-nav">
  <section class="content">
    <nav>
      <ul class="unstyled">
        <li><a href="https://global.ihs.com?rid=IHS">Purchase Standards</a></li>
        <li><a href="https://ihsmarkit.com/about/contact-us.html">Contact Us</a></li>
        <li><a href="http://news.ihsmarkit.com/">Newsroom</a></li>
        <li><a href="http://investor.ihsmarkit.com/">Investor Relations</a></li>
        <li class="customer-login"><a href="https://ihsmarkit.com/login.html">Login</a></li>
      </ul>
    </nav>
  </section>
</header>
<header class="topnav">
  <section class="content">
    <div class="top-nav logo">
      <a href="https://ihsmarkit.com/index.html"><img src="https://cdn.ihsmarkit.com/www2/a/p/media/images/rgb.svg"
                                                      style="width: 100%" alt="IHS Logo"></a>
    </div>
    <nav class="component-menu component-menu0" data-component="true" data-component-id="component-menu0">
      <div class="mobile-menu desktop-hidden">
        <a href="javascript:void(0);">
          <span class="ihs-menu"></span>
        </a>
      </div>
      <div class="top-level-nav search auto desktop-hidden mobile-utility">
        <a href="javascript:void(0);" class="search-btn"><span class="ihs-search top"></span></a>
        <div class="submenu">
          <div class="close-menu mobile-hidden"><a href="javascript:void(0);">Close X</a></div>
          <form id="global_search_form" action="">
            <div class="search-input">
              <input type="text" class="menu-search ui-autocomplete-input" placeholder="What are you searching for?"
                     id="searchflyout" name="search" autocomplete="off">
              <button (click)="globalSearch()">
                <span class="ihs-search"></span></button>
            </div>
            <div class="content">
              <div class="row">
                <div class="grid-4 common-search" style="z-index: 0;">
                  <ul class="ui-autocomplete ui-front ui-menu ui-widget ui-widget-content" id="ui-id-1" tabindex="0"
                      style="display: none;"></ul>
                </div>
                <div class="grid-8 recommended-results"></div>
                <input type="hidden" id="commonSearchText" value="COMMON SEARCH TERMS">
                <input type="hidden" id="recommendedText" value="RECOMMENDED RESULTS"><input type="hidden"
                                                                                             id="searchPlaceHolderText"
                                                                                             value="What are you searching for?">
                <input type="hidden" id="searchWithinPlaceHolderText" value="Search within results.">
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="drop-down-menu">
        <div class="clearfix" id="mega-menu">
          <div class="top-level-nav">
            <a href="https://ihsmarkit.com/products.html">SOLUTIONS</a>
            <div class="submenu two-column">
              <div class="nav-section-one" style="height: 346px;">
                <h3>Industries</h3>
                <ul class="column-one">
                  <li class=""><a href="https://ihsmarkit.com/industry/academic-education.html">Academic &amp;
                    Education</a></li>
                  <li class="visible-menu"><a href="https://ihsmarkit.com/industry/aerospace-defense.html">Aerospace,
                    Defense</a></li>
                  <li class=""><a href="https://ihsmarkit.com/industry/agribusiness.html">Agribusiness</a></li>
                  <li class=""><a href="https://ihsmarkit.com/industry/automotive.html">Automotive</a></li>
                  <li class=""><a href="https://ihsmarkit.com/industry/chemical.html">Chemical</a></li>
                  <li class=""><a href="https://ihsmarkit.com/industry/construction.html">Construction</a></li>
                </ul>
                <ul class="column-two">
                  <li class=""><a href="https://ihsmarkit.com/industry/energy.html">Energy &amp; Natural Resources</a>
                  </li>
                  <li class=""><a href="https://ihsmarkit.com/industry/financial-markets.html">Financial Services</a>
                  </li>
                  <li class=""><a href="https://ihsmarkit.com/industry/insurance.html">Insurance</a></li>
                  <li class=""><a href="https://ihsmarkit.com/industry/maritime.html">Maritime &amp; Trade</a></li>
                  <li class=""><a href="https://ihsmarkit.com/industry/retail.html">Retail</a></li>
                </ul>
              </div>
              <div class="nav-section-two" style="height: 346px;">
                <h3>Cross Industries</h3>
                <ul class="column-one">
                  <li class=""><a href="https://ihsmarkit.com/industry/Climate-Sustainability.html">Climate and Sustainability</a></li>
                  <li class=""><a href="https://ihsmarkit.com/industry/economics-country-risk.html">Economics &amp;
                    Country Risk</a></li>
                  <li class="visible-menu"><a
                    href="https://ihsmarkit.com/industry/engineering-intelligence.html">Engineering Intelligence </a></li>
                </ul>
              </div>
              <div class="nav-section-three" style="height: 346px;">
                <h3>Trending Topics</h3>
                <ul class="column-one">
                  <li class=""><a href="https://ihsmarkit.com/topic/all-trending-topics.html">All Trending Topics</a></li>
                  <li class="visible-menu"><a href="https://ihsmarkit.com/topic/future-of-air-cargo-trade.html">Future of Air Cargo and Trade</a></li>
                  <li class=""><a href="https://ihsmarkit.com/topic/eu-economic-recovery-fund-for-central-europe.html">Role of Emerging Markets</a></li>
                  <li class=""><a href="https://ihsmarkit.com/topic/mobility-of-the-future.html">Mobility of the Future</a></li>
                  <li class=""><a href="https://ihsmarkit.com/topic/ibor.html">Get ahead of Interbank Offered Rate(IBOR) benchmark reform</a></li>
                  <li class="visible-menu"><a href="https://ihsmarkit.com/topic/market-cycles-key-developments.html">Market Cycles and Key Developments</a></li>
                  <li class=""><a href="https://ihsmarkit.com/topic/alternative-data-and-insights.html">Alternative Data and Insights</a></li>
                  <li class=""><a href="https://ihsmarkit.com/system/statichtml/megamenu.txt">Oil Industry Crisis</a></li>
                  <li class=""><a href="https://ihsmarkit.com/topic/coronavirus-market-impact.html">Coronavirus Resource Centre</a></li>
                </ul>
              </div>
              <div class="nav-section-three" style="height: 346px;">
                <h3>Featured Solutions</h3>
                <ul class="column-one">
                  <li class=""><a href="https://ihsmarkit.com/products/data-lake.html">Data Lake</a></li>
                  <li class="visible-menu"><a href="https://ihsmarkit.com/products/expert-network.html">Experts by IHS Markit</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="top-level-nav">
            <a class="dropdown" href="https://ihsmarkit.com/expertise/index.html">
              <span class="desktop-hidden ihs-down"></span>EXPERTISE
            </a>
            <div class="submenu one-column">
              <div>
                <p class="menu-text">Find the solutions you need by accessing our extensive portfolio of information, analytics and expertise.
                  The IHS Markit team of subject matter experts, analysts and consultants offers the actionable intelligence you need to make
                  informed decisions.
                </p>
                <ul>
                  <li>
                    <a href="https://ihsmarkit.com/research-analysis/index.html">
                      <h3>Research and Analysis</h3>
                      <p>Critical analysis and guidance spanning the world's most important business issues.</p>
                    </a>
                    <div class="menu-container">
                      <ul>
                        <li><a href="https://ihsmarkit.com/research-analysis/index.html"><span>All</span></a></li>
                        <li><a href="https://ihsmarkit.com/research-analysis/agribusiness.html"><span>Agribusiness</span></a></li>
                        <li><a href="https://ihsmarkit.com/research-analysis/automotive.html"><span>Automotive</span></a></li>
                        <li><a href="https://ihsmarkit.com/research-analysis/chemical.html"><span>Chemical</span></a></li>
                        <li><a href="https://ihsmarkit.com/research-analysis/economics-country-risk.html"><span>Economics &amp; Country Risk</span></a></li>
                        <li><a href="https://ihsmarkit.com/research-analysis/energy.html"><span>Energy &amp; Natural Resources</span></a></li>
                      </ul>
                      <ul>
                        <li><a href="https://ihsmarkit.com/research-analysis/financial-markets.html"><span>Financial Services</span></a></li>
                        <li><a href="https://ihsmarkit.com/research-analysis/maritime-trade.html"><span>Maritime &amp; Trade</span></a></li>
                        <li><a href="https://cleanenergynews.ihsmarkit.com/"><span>Net-Zero Business Daily&trade;</span></a></li>
                        <li><a href="https://ihsmarkit.com/research-analysis/pmi.html"><span>PMI&trade; Commentary & Analysis</span></a></li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <a href="https://ihsmarkit.com/podcasts/index.html">
                      <h3>Podcasts</h3>
                      <p>Stay abreast of changes, new developments and trends in their industry.</p>
                    </a>
                    <div class="menu-container">
                      <ul>
                        <li><a href="https://ihsmarkit.com/podcasts/automotive.html"><span>Automotive</span></a></li>
                        <li><a href="https://ihsmarkit.com/podcasts/ecr.html"><span>Economics &amp; Country Risk</span></a></li>
                        <li><a href="https://ihsmarkit.com/podcasts/energy-services.html"><span>Energy </span></a></li>
                      </ul>
                    </div>
                  </li>
                  <li><a href="https://ihsmarkit.com/experts/index.html"><h3>Experts</h3>
                    <p>A global team of industry-recognized experts contributes incisive and thought-provoking
                      analysis.</p></a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="top-level-nav">
            <a href="https://ihsmarkit.com/events/index.html">EVENTS</a>
            <div class="submenu one-column">
              <div>
                <p class="menu-text">Broaden your knowledge by attending IHS Markit events that feature our subject-matter experts.
                  Find webinars, industry briefings, conferences, training and user groups.
                </p>
                <ul>
                  <li>
                    <a href="https://ihsmarkit.com/events/index.html?filterby=Online">
                      <h3>Online Events</h3>
                      <p>During COVID-19, IHS Markit is offering more online events for the safety of our guests.</p>
                    </a>
                  </li>
                  <li>
                    <a href="https://ihsmarkit.com/events/index.html?filterby=In-Person">
                      <h3>In-Person Events</h3>
                      <p>IHS Markit will resume our in-person events once it is safe to do so.</p>
                    </a>
                  </li>
                  <li><a href="https://ihsmarkit.com/events/index.html?filterby=On-Demand">
                    <h3>On-Demand Events</h3>
                    <p>Missed an event or webinar? Review the recordings of past online events.</p></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="top-level-nav">
            <a class="dropdown" href="https://ihsmarkit.com/company/index.html">
              <span class="desktop-hidden ihs-down"></span>COMPANY
            </a>
            <div class="submenu  five-column">
              <div>
                <ul>
                  <li><a href="https://ihsmarkit.com/about/index.html"><h3>About Us</h3>
                    <p>IHS Markit is the leading source of information and insight in critical areas that shape today's business landscape.
                      Customers around the world rely on us to address strategic and operational challenges.
                    </p></a></li>
                  <li><a href="https://ihsmarkit.com/about/executives.html"><h3>Executive Management</h3>
                    <p>The experts and leaders who set the course for IHS Markit and its thousands of colleagues around the
                      world.</p></a></li>
                  <li><a href="https://ihsmarkit.com/about/corporate-sustainability.html"><h3>Corporate
                    Sustainability</h3>
                    <p>Sustainability drives the entire IHS Markit enterprise.
                      It's how we do business by guiding our values and culture on the notion that we can make a difference.</p></a></li>
                  <li><a href="https://careers.ihsmarkit.com/"><h3>Careers</h3>
                    <p>Join a global business leader that is dedicated to helping businesses make the right decisions.
                      Be a part of a family of professionals who thrive in an exciting work environment.</p></a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="top-level-nav search auto">
            <a href="javascript:void(0);" class="search-btn">
              <span class="ihs-search top"></span>
            </a>
            <div class="submenu">
              <div class="close-menu"><a href="javascript:void(0);">Close X</a></div>
              <form id="global_search_form" action="">
                <div class="search-input">
                  <input type="text" class="menu-search ui-autocomplete-input" placeholder="What are you searching for?"
                         id="searchKey" name="search" autocomplete="off">
                  <button (click)="globalSearch()">
                    <span class="ihs-search"></span></button>
                </div>
                <div class="content">
                  <div class="row">
                    <div class="grid-4 common-search" style="z-index: 0;">
                      <ul class="ui-autocomplete ui-front ui-menu ui-widget ui-widget-content" id="ui-id-2" tabindex="0"
                          style="display: none;"></ul>
                    </div>
                    <div class="grid-8 recommended-results"></div>
                    <input type="hidden" id="commonSearchText" value="COMMON SEARCH TERMS">
                    <input type="hidden" id="recommendedText" value="RECOMMENDED RESULTS">
                    <input type="hidden" id="searchPlaceHolderText" value="What are you searching for?">
                    <input type="hidden" id="searchWithinPlaceHolderText" value="Search within results.">
                  </div>
                </div>
              </form>
            </div>
          </div>
          <script>
            var siteID = "1109";
            var locale = "";
            var isLandingPage = false;
            var isEventLandingPage = false;
            var isExpertLandingPage = false;
            var isCustomerLandingPage = false;
            var isSearchPage = false;
            var solrCoreAndWeightage = "";
            var isSearchResultPage = false;
            var isIndustryLandingPage = false;
            var isChemicalPage = false;
            var isProductTypePage = false;
            var megaMenuEventCount = "4";
            var isRollUpPage = false;
            var isExpertBioPage = false;
            var proximity = "50";
            var urlweightage = "5.0";
            var titleweightage = "10.0";
            var bodyweightage = "2.0";
            var descriptionweightage = "5.0";
            var maxAgendaCount = 4;
            var hideTaxonomyButtons = "false";
            var BRE = "5";
            var ChemWeek = "3";
            var Ecommerce = "10";
            var Global_Insight = "3";
            var GlobalStore = "10";
            var IHSCORE = "70";
            var LandingPages = "15";
            var OHSIS = "5";
            var Technology = "8";
            var IHSRSSFeeds = "8";
            var isPinnedResult = false;
            var pinnedResultFound = 0;
            var featurePageLink = "";
            var isBlogLandingPage = false;
          </script>
        </div>
        <header class="utility-nav desktop-hidden mobile-utility">
          <section class="content">
            <nav>
              <ul class="unstyled">
                <li><a href="https://global.ihs.com?rid=IHS">Purchase Standards</a></li>
                <li><a href="https://ihsmarkit.com/about/contact-us.html">Contact Us</a></li>
                <li><a href="http://news.ihsmarkit.com/">Newsroom</a></li>
                <li><a href="http://investor.ihsmarkit.com/">Investor Relations</a></li>
                <li class="customer-login" href="https://ihsmarkit.com/system/statichtml/top_header.txt"><a
                  href="javascript:void(0);">Login</a></li>
              </ul>
            </nav>
          </section>
        </header>
      </div>
    </nav>
  </section>
</header>
